import Const from 'constants';
import Action from 'actions';

const NhlLegacyTeamStackingAction = {
    useStacking(use) {
        return {
            type: Const.NHL_LEGACY_TEAM_STACKING_IS_USED,
            use,
        };
    },

    setTeams(teams) {
        return {
            type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAMS,
            teams,
        };
    },

    setTeamsAreChosenRandomly(chooseTeamsRandomly) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
                chooseTeamsRandomly,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setTeamsAreForcedToStacking(forceTeamsToStacking) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAMS_ARE_FORCED_TO_STACKING,
                forceTeamsToStacking,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setStackTeamsIsCheckedForStackNumber(checked, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED,
                checked,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setStackTeamsExposureForStackNumber(exposure, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE,
                exposure,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setLineGroupsForStackNumber(lineGroups, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_LINE_GROUP_IS_CHECKED,
                lineGroups,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setTeamLineGroupsForStackNumber(lineGroups, team, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_LINE_GROUPS,
                lineGroups,
                team,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setPPLinesForStackNumber(ppLines, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_PP_LINE_IS_CHECKED,
                ppLines,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setTeamPPLinesForStackNumber(ppLines, team, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_PP_LINES,
                ppLines,
                team,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setTeamIsCheckedForStackNumber(team, checked, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_IS_CHECKED,
                team,
                checked,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setTeamExposureForStackNumber(team, exposure, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_EXPOSURE,
                team,
                exposure,
                stackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setCombinationIsChecked(comboKey, checked) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_COMBO_IS_CHECKED,
                comboKey,
                checked,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setCombinationExposure(comboKey, exposure) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_SET_COMBO_EXPOSURE,
                comboKey,
                exposure,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    setNhlLegacyTeamStackingSettingsFromStorage(data) {
        return {
            type: Const.NHL_LEGACY_TEAM_STACKING_SET_DATA_FROM_STORAGE,
            data,
        };
    },

    mirrorStack(sourceStackNumber, destinationStackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_LEGACY_TEAM_STACKING_MIRROR_STACK,
                sourceStackNumber,
                destinationStackNumber,
            });

            dispatch(this.saveNhlLegacyTeamStackingToStorage());
        };
    },

    saveNhlLegacyTeamStackingToStorage() {
        return (dispatch) => {
            dispatch(Action.saveDataToStorage('nhlLegacyTeamStackingSettings', function (state) {
                const {nhlLegacyTeamStacking} = state;

                return {...nhlLegacyTeamStacking.data};
            }));
        }
    },
};

export default NhlLegacyTeamStackingAction;